import BaseController from "akademika/akamont/pages/sharedControllers/BaseController";
import { ILogFormatter } from "./ILogFormatter";
import Control from "sap/ui/core/Control";
import Text from "sap/m/Text";

export class BaseLogFormatter implements ILogFormatter {
  protected _controller: BaseController;

  constructor(baseController: BaseController) {
    this._controller = baseController;
  }

  getTextForBooleanValue(value: string | null | undefined) {
    return value === "true"
      ? this._controller.translate("yes")
      : value === "false"
        ? this._controller.translate("no")
        : value;
  }

  /** "value" should contain comma-separated service and measurement unit translation keys */
  getTextForServiceMeasurementUnit(value: string | null | undefined) {
    const segments = value?.split(",");
    if (!segments || segments.length < 2) {
      return this.generateTextControl(value);
    }
    const translatedText =
      this._controller.translateDynamic(segments[0]) +
      " / " +
      this._controller.translateDynamic(segments[1]);

    return this.generateTextControl(translatedText);
  }

  generateTextControl(value?: string | null | undefined) {
    return new Text({
      text: value || "N/A",
    });
  }

  generateControlForValue(
    value: string | null | undefined,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fieldName: string
  ): Control {
    return this.generateTextControl(value);
  }

  generateTextControlForObject(value?: string | null | undefined) {
    const text = new Text();
    text.setText(value || "N/A");
    return text;
  }

  generateControlForValueObject(
    value: string | null | undefined,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fieldName: string
  ): Control {
    return this.generateTextControlForObject(value);
  }
}
